import { CheckSquare, Square, ArrowLeft } from "lucide-react";

export const CompilerVideoSelector = ({
  playlist, videos, selectedIds, onToggle, onSelectAll, onClear, onBack,
  titleHint, onTitleHint, privacy, onPrivacy, onCompile, compiling,
}) => {
  return (
    <div data-testid="compiler-video-selector" className="space-y-5">
      <div className="flex items-center justify-between">
        <button
          data-testid="compiler-back-to-playlists"
          onClick={onBack}
          className="flex items-center gap-1.5 text-slate-400 hover:text-white text-sm transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Back to playlists
        </button>
        <div className="flex gap-2">
          <button data-testid="compiler-select-all" onClick={onSelectAll} className="text-xs font-mono text-indigo-400 hover:text-indigo-300">
            Select all
          </button>
          <button data-testid="compiler-clear-selection" onClick={onClear} className="text-xs font-mono text-slate-500 hover:text-slate-300">
            Clear
          </button>
        </div>
      </div>

      <h3 className="font-heading text-lg font-semibold text-slate-100">{playlist.title}</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-[420px] overflow-y-auto pr-1">
        {videos.map((v) => {
          const checked = selectedIds.includes(v.video_id);
          return (
            <button
              key={v.video_id}
              data-testid="compiler-video-item"
              onClick={() => onToggle(v.video_id, v.title)}
              className={`flex items-center gap-3 text-left p-2.5 rounded-xl border transition-all ${
                checked ? "border-indigo-400/60 bg-indigo-400/10" : "border-slate-800 bg-slate-900/60 hover:border-slate-700"
              }`}
            >
              {checked ? <CheckSquare className="w-4 h-4 text-indigo-400 shrink-0" /> : <Square className="w-4 h-4 text-slate-600 shrink-0" />}
              {v.thumbnail && <img src={v.thumbnail} alt={v.title} className="w-16 h-9 object-cover rounded-md shrink-0" />}
              <span className="text-sm text-slate-200 line-clamp-2">{v.title}</span>
            </button>
          );
        })}
      </div>

      <div className="bg-slate-900/60 border border-slate-800/80 rounded-2xl p-5 space-y-4">
        <div>
          <label className="text-xs font-mono text-slate-500 mb-1.5 block">Compilation title hint (optional)</label>
          <input
            data-testid="compiler-title-hint-input"
            value={titleHint}
            onChange={(e) => onTitleHint(e.target.value)}
            placeholder="e.g. Krishna Bhajans"
            className="w-full bg-slate-950/80 border border-slate-800 text-slate-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-indigo-400/50"
          />
        </div>
        <div>
          <label className="text-xs font-mono text-slate-500 mb-1.5 block">Privacy on upload</label>
          <select
            data-testid="compiler-privacy-select"
            value={privacy}
            onChange={(e) => onPrivacy(e.target.value)}
            className="w-full bg-slate-950/80 border border-slate-800 text-slate-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-indigo-400/50"
          >
            <option value="private">Private</option>
            <option value="unlisted">Unlisted</option>
            <option value="public">Public</option>
          </select>
        </div>
        <button
          data-testid="compiler-compile-button"
          onClick={onCompile}
          disabled={selectedIds.length < 2 || compiling}
          className="w-full bg-indigo-500 hover:bg-indigo-400 text-black font-semibold px-5 py-3 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {compiling ? "Starting..." : `Compile ${selectedIds.length} videos & Upload`}
        </button>
        {selectedIds.length > 0 && selectedIds.length < 2 && (
          <p className="text-xs text-amber-400">Select at least 2 videos to compile.</p>
        )}
      </div>
    </div>
  );
};
